/*
 * @Author: yusha
 * @Date: 2023-07-28 19:44:57
 * @LastEditors: huajian
 * @LastEditTime: 2024-03-11 16:58:10
 * @Description:
 */
export default {
  ja: {
    '-1': 'エラーあり カスタマーサービスへご連絡下さい',
    1001: '入力不備　お届け先情報 有効な住所を入力して下さい',

    1002: '削除済商品あり',
    1003: 'THE CKB商品と紐付けない商品があります',
    1004: '発注不可，運送会社設定実施後、発注可能',
    1005: '該当店舗の口座残高不足，資金をチャージ後、発注をお願いします',
    1006: '在庫不足商品があります',
    1007: '商品オプションをご選択下さい',
    1008: '注文上限額超過，D2C直送の注文合計額上限は、2000元/回　です',
    1013: '詳細住所は40文字以内で入力してください',
    1014: 'この注文には日本円価格商品が含まれており、APIで注文できません。ご確認の上、改めて紐づけてからご注文ください',
    22010002: '残高不足口座残高をチャージして下さい',
    22010071: '在庫不足で直送注文の発注に失敗しました、組合せ商品は先に在庫保有注文をご発注下さい',
    22010003: '注文上限額超過，D2C直送の注文合計額上限は、2000元/回　です',
    22010079: '発注不可：未登録状態であり、会員登録をして下さい', // API订单下单失败：会员等级不足
    22010081: '発注不可：在庫切れ', // 购物车商品已下架
    22010000: 'システムエラーが発生しました。', // 订单服务异常
    22010084: '発注不可：URL切れ', // 购物车商品已失效
    22010092: 'OEM在庫不足のため、発注できません',
    20000005: 'THE CKB在庫数不足', // 商品库存不足
    // 220101012: '发货单确认失败', // 发货单确认失败
    220101015: '注文書は未承認で完了しており、一時的に優先的に出荷することはできません',
    22010056: 'エラーが発生しました<br/>カスタマサービスにご連絡ください', // API订单下单失败：寻源单销售价格为空
    1010: 'お届け先国に選択可能な配送ルートがありません<br/>カスタマサービスにお問い合わせください',
    1011: '対象国への配送はサポートしていません',
    1012: 'お届け先情報不備：【国】を修正する必要があります',
    100021: '这个的翻译 제3자 플랫폼 로그인 인증 실패',
    // 黑名单商品不支持下单
    240000012: 'ブラックリストに載っている商品は仕入れできません',
    // 存在未授权的品牌商品
    220101019: 'ブランドライセンス未取得のため、発注できません',
    240000014: '卸売最小ロット数未達、手動発注必要、右側の発注ボタンをクリックしてご確認下さい',
    240000015: '一括分納発送を行う注文は最大200件までです',
    240000016: '選択された注文は分納発送できません',
    240000017: 'すでにバッチ処理中です。分納発送をご希望の場合は、注文を個別に処理して下さい',
    22041027: '同じAmazon skuを持つ、違う仕入れ先から仕入れた商品があります。 新規納品プランを作成し、重複している商品を分割発送してください',
    240000020: 'データが更新されたため、オプションを再編集する必要があります',
    8000: 'ご契約のプランでは、この配送方法に対応できません。配送方法を変更してから費用を確認して下さい',
    8001: 'ご契約のプランでは、このオプションを対応できません',
    8002: '重量を満たさません（>Xkg）',
    8003: '発送できる重量を超過しています（＜Xkg）',
    8005: '取扱商品の種類が複数あるため、分割発送する可能性があります',
    8006: 'この運送会社では、X を発送対応できません',
    240000035: 'エラーが発生しました。洗濯タグ仕様が設定されていません',
    20000002: '注文データが存在しません',
    241000001: '発注不可：現在ご利用中の店舗では、「CKB Choice」商品を購入することはできません。',
    40000201: 'この商品は紐付けできません',
    40000309: '該当注文は自動発注に対応していません',
    40000310: '【発注不要】エンドユーザー様都合でキャンセル済み',
    20000000: 'ただいま処理中です。繰り返し操作はご遠慮ください'
  },
  ko: {
    '-1': 'エラーあり カスタマーサービスへご連絡下さい',
    1001: '주소를 사용할 수 없습니다. 수정 후 다시 시도하십시오.',
    1002: '주문하신 상품이 존재하지 않습니다.',
    1003: '일부상품은 연관 구매링크 없음.',
    1004: '점포 기본 물류방식 미설정.',
    1005: '점포 기본 물류방식 미설정',
    1006: '상품 재고 부족',
    1007: '추가항목을 선택하십시오.',
    1008: 'D2C 주문 상품 금액이 2,000위안을 초과합니다.',
    1010: '물류회사가 존재하지 않습니다.',
    1013: '상세 주소는 40개 글자 초과 불가',
    22010002: '지갑 잔고 부족',
    22010071: '조합 상품 재고부족으로 주문실패',
    22010003: '매번 주문 금액은2,000위안을 초과할 수 없으니, 상품 수량을 조절하십시오.',
    22010079: 'API 주문 실패: 멤버십 등급 부족', // API订单下单失败：会员等级不足
    22010081: 'API 주문 실패: 관련 상품 진열 제거', // 购物车商品已下架
    22010084: 'API 주문 실패: 관련 상품이 효력을 잃었습니다.', // 购物车商品已失效
    22010092: 'OEM 재고부족으로 주문 실패',
    20000005: '상품 재고 부족', // 商品库存不足
    220101012: '송장 확인 실패',
    220101015: '주문 심사가 완료되지 않아 당분간 우선 발송이 불가합니다.',
    22010056: 'API 주문 실패: 판매 가격 0', // API订单下单失败：寻源单销售价格为空
    1011: '물류 회사는 해당 국가의 배송을 지원하지 않습니다.',
    1012: '국가정보가 잘못되었습니다. 수신정보를 편집하십시오.',
    // 黑名单商品不支持下单
    240000012: '블랙리스트 상품은 주문할 수 없습니다.',
    // 存在未授权的品牌商品
    220101019: '인증되지 않은 브랜드 상품이 존재함.',
    240000014: 'API 주문 실패, 최소 주문 수량 미달, 수동 주문 필요.',
    22041027: '동일한 Amazon sku가 존재하므로 분할하여 발송해 주시기 바랍니다.',
    240000020: '선택하신 부가항목을 업데이트 했습니다! 다시 선택하시길 바랍니다!',
    8000: '현재 회원 등급은 선택한 물류를 지원하지 않으며, 이 비용은 총비용에 포함되지 않으므로 재선택을 추천합니다.',
    8001: '현재 회원등급은 지원되지 않습니다.',
    8002: '최소 출고 가능 중량 X 미달',
    8003: '무게가 Xkg 제한을 초과했습니다.',
    8005: ' 현재 소포 신고 수량이 물류업체가 설정한 최대 신고 수량 제한을 초과합니다:X',
    8006: '이 물류는 하전 및 자석 상품을 운송할 수 없습니다.',
    240000035: '점포에서 워싱라벨 미설정'
  },
  zh: {
    '-1': 'エラーあり カスタマーサービスへご連絡下さい',
    1001: '地址不可用，请修改后重试',
    1002: '订单下的商品不存在',
    1003: '部分商品未关联采购链接',
    1004: '店铺默认物流方式未设置',
    1005: '钱包余额不足',
    1006: '商品库存不足',
    1007: '请选择附加项',
    1008: 'D2C直发订单商品金额超过2000元',
    1010: '物流公司不存在货代公司',
    1013: '详细地址不能超过40个字符',
    22010002: '钱包余额不足',
    22010071: '组合商品库存不足，下单失败',
    22010003: '单笔订单价值不得超过2000元，请调整商品数量',
    22010079: 'API订单下单失败：会员等级不足', // API订单下单失败：会员等级不足
    22010081: 'API下单失败：关联商品已下架', // 购物车商品已下架
    22010084: 'API下单失败：关联商品已失效', // 购物车商品已失效
    22010092: 'OEM库存不足，下单失败',
    20000005: '商品库存不足', // 商品库存不足
    220101012: '发货单确认失败',
    220101015: '订单未审单完成，暂时无法优先发货',
    22010056: 'API订单下单失败：寻源单销售价格为空', // API订单下单失败：寻源单销售价格为空
    1011: '物流公司不支持该国家发货',
    1012: '国家信息错误，请编辑收件信息',
    // 黑名单商品不支持下单
    240000012: '黑名单商品不支持下单',
    // 存在未授权的品牌商品
    220101019: '存在未授权的品牌商品',
    240000014: 'API下单失败，不满足最小起订量，需手动下单',
    240000015: '批量有限发货超过限制,限制200',
    240000016: '所选订单无法优先发货',
    240000017: '已经存在提前发货任务',
    20000000: '当前订单正在处理中，请勿重复操作'
  },
  en: {
    1001: 'Incomplete input information. Please enter valid receiving address information',
    1002: 'There are deleted goods',
    1003: "There are goods that are not related to the ckb's goods.",
    1004: 'Can not be ordered, after the transport company set, can be ordered',
    1005: 'The Sub-account balance is insufficient, please recharge before ordering.',
    1006: 'Goods with insufficient stock',
    1007: 'Please select an item option',
    1008: 'If the order limit is exceeded, the total order limit for D2C direct delivery is 2000 yuan/time.',
    1013: 'The detailed address cannot exceed 40 words.',
    22010002: 'Please recharge the account balance with insufficient balance',
    22010071: 'Due to insufficient inventory, direct delivery order failed, please order inventory first for combination goods.',
    22010003: 'If the order limit is exceeded, the total order limit for D2C direct delivery is 2000 yuan/time.',
    22010079: 'Unable to order: unregistered status, please register as a member', // API订单下单失败：会员等级不足
    22010081: 'Unable to Order: No Inventory', // 购物车商品已下架
    22010000: 'A system error has occurred.', // 订单服务异常
    22010084: 'Unable to order: URL has expired', // 购物车商品已失效
    22010092: 'Unable to order due to insufficient OEM inventory',
    20000005: 'THE CKB stock is insufficient', // 商品库存不足
    // 220101012: '发货单确认失败', // 发货单确认失败
    220101015: 'The order was completed without approval and priority delivery cannot be given for the time being.',
    22010056: 'An error has occurred', // API订单下单失败：寻源单销售价格为空
    1010: 'no suitable logistics company',
    1011: 'Delivery to target country not supported',
    1012: "Incomplete recipient information: Need to correct the information 'country'",
    // 黑名单商品不支持下单
    240000012: 'Blacklisted products are not supported for place order',
    // 存在未授权的品牌商品
    220101019: 'Existence of unauthorized branded goods',
    240000014: 'API order failure, does not meet the moq, need to manually place orders',
    240000017: 'There is already an early shipment task',
    240000015: 'Bulk limited shipment over the limit, limit 200',
    240000016: 'Selected orders can not be prioritized shipping',
    22041027: 'Same amazon sku exists, please ship separately!',
    240000020: 'Your selected add-on service have been updated, please re-edited it',
    8000: 'The current membership level does not support your choice logistics, the cost is not included in the total cost, we recommend to re-option',
    8001: 'Current member level does not support',
    8002: 'does not meet the minimum shipping weight X kg',
    8003: 'weight exceeds X kg limit',
    8005: 'Orders may be split shipped',
    8006: 'the logistics can not transport X goods',
    240000035: 'The store has not yet configured the washing label template'
  }
}
